import { $http } from "../request"
export interface checkAfterSaleApplyParams {
    saleOrderId: number,
    saleOrderSkuId: number
}
/** 检查当前订单是否可以售后 */
export const checkAfterSaleApplyApi = (params: checkAfterSaleApplyParams) =>
    $http.post({ url: `/aftersale/v1/aftersale-process/apply-data`, body: params }).then((r: any) => r.data)

export interface BatchAfterSaleApplyResult {
    saleOrderSkuId: number,
    canApply: boolean
}
/** 批量检查订单商品是否可以申请售后（每次最多 20 个） */
export const checkAfterSaleBatchApplyApi = (params: { saleOrderSkuId: number[] }): Promise<BatchAfterSaleApplyResult[]> =>
    $http.post({ url: `/aftersale/v1/aftersale-process/batch-apply-data`, body: params }).then((r: any) => r.data)

/** 售后申请参数 */
export interface AfterSaleApplyParams {
    saleOrderId: number,
    saleOrderSkuId: number,
    applyQuantity: number,
    serviceType: string,
    reasonId: number,
    applyRefundAmount: number,
    remark: string,
    attachment: string[],
    fromSource: string,
    gifts?: Array<{
        saleOrderSkuId: number,
        applyQuantity: number,
    }>,
    repairItemIds?: number[],
    requirementAttachments?: Array<{
        requirementId: number,
        attachment: {
            content: string,
            attachType: 'image' | 'video'
        }
    }>,
    /** 换货目标 SKU ID */
    exchangeSkuId?: number,
    /** 换货目标规格描述 如 "Black,M" */
    exchangeSpec?: string
}
/** 申请售后 */
export const applyAfterSaleApi = (params: AfterSaleApplyParams) =>
    $http.post({ url: `/aftersale/v1/aftersale-process/apply`, body: params }).then((r: any) => r.data)

/** 售后可申请数据接口的参数 */
export interface AfterSaleCanApplyParams {
    lastId?: number,
    pageSize?: number,
}
/** 获取售后可申请列表 */
export const getAfterSaleCanApplyApi = (params: AfterSaleCanApplyParams) =>
    $http.get({ url: `/baseorder/v1/order/after-sale-skus`, params: params }).then((r: any) => r.data)

export interface AfterSaleListParams {
    limit?: number,
    offset?: number,
    status?: string,
    includeReviewStatus?: boolean,
}
/** 获取售后列表 */
export const getAfterSaleApplyApi = (params: AfterSaleListParams) =>
    $http.get({ url: `/aftersale/v1/aftersale-process/list`, params: params }).then((r: any) => r.data)

/**获取售后原因列表 */
export const getAfterSaleReasonApi = (groupCode: string) =>
    $http.get({ url: `/aftersale/v1/groups/get-group-by-code/${groupCode}` }).then((r: any) => r.data)

/**获取售后详情 */
export const getAfterSaleDetailApi = (aftersaleId: number) =>
    $http.get({ url: `/aftersale/v1/aftersale-process/aftersale-detail/${aftersaleId}` , loading: true}).then((r: any) => r.data)

/** 取消售后 */
export const cancelAfterSaleApi = (aftersaleId: number) =>
    $http.post({ url: `/aftersale/v1/aftersale-process/cancel-aftersale/${aftersaleId}`, loading: true }).then((r: any) => r.data)

export type AppealStatusType = 'pending' | 'accepted' | 'appeal'
/** 申诉售后参数 */
export interface AppealAfterSaleParams {
    status: AppealStatusType, 
    appealAttachment?: string[],
    appealReasonId?: number,
    appealRemark?: string,
}
/** 确认/申诉售后 */
export const appealAfterSaleApi = (aftersaleId: number, params: AppealAfterSaleParams) =>
    $http.post({ url: `/aftersale/v1/aftersale-process/aftersale-user-audit/${aftersaleId}`, body: params }).then((r: any) => r.data)

/** 获取老售后入口配置信息 */
export const getAfterSaleEntryConfigApi = () =>
    $http.get({ url: `/aftersales-entry-config` }).then((r: any) => r.data)
/** 获取新售后统计数量 */
export const getNewAfterSaleCountApi = () =>
    $http.get({ url: `/aftersale/v1/aftersale-process/aftersale-status-count` }).then((r: any) => r.data)

export interface ReturnOperateParams {
    status: 'send',
    transitType: 'door' | 'kilishop' | 'self',
    returnInfo: {
        areaNameList: {
            name: string,
            id: number,
        }[],
        address: string,
        phone: string,
        name: string,
        pickupStationId: string,
    },
    expressSn: string,
    expressName: string,
}
/** 售后退回货物操作 */
export const returnAfterSaleApi = (aftersaleId: string, params: ReturnOperateParams) =>
    $http.post({ url: `/aftersale/v1/aftersale-return/return-operate/${aftersaleId}`, body: params }).then((r: any) => r.data)

export interface GetAfterReturnPointParams { areaId?: number, kilishopId?: number | string }
/** 售后退回货物操作-获取售后的自提点(网点)列表 */
export const getAfterReturnPointApi = (params: GetAfterReturnPointParams) =>
    $http.get({ url: `/aftersale/v1/aftersale-service-point/buyer-service-point`, params }).then((r: any) => r.data)
/** 售后退回货物操作-自发货售后揽收地址 */
export const getReceiveServicePointApi = (afterSareId: number) =>
    $http.get({ url: `/aftersale/v1/aftersale-service-point/receive-service-point`, params: { aftersaleId: afterSareId } }).then((r: any) => r.data)

/** 获取售后规则地址链接 */
export const getAfterRuleUrlApi = (key: string = 'aftersale_rules') =>
    $http.get({ url: `/aftersale/v1/configs/key/${key}` }).then((r: any) => r.data)

/** 检查当前申请售后是否支持体验退款(极速仅退款/先行退款) */
export const checkAfterSaleRefundCheckApi = ( params: { aftersaleId: number }) =>
    $http.post({ url: `/aftersale/v1/aftersale-process/aftersale-quick-refund-check`, body: params }).then((r: any) => r.data)
/** 用户同意或拒绝体验退款(极速仅退款/先行退款) */
export const agreeOrRefuseAfterSaleRefundApi = ( params: { aftersaleId: number, isAccept: boolean }) =>
    $http.post({ url: `/aftersale/v1/aftersale-process/aftersale-quick-refund`, body: params }).then((r: any) => r.data)

/** 售后评论参数 */
export interface SubmitAfterSaleReviewParams {
    aftersaleId: number,
    customerServiceScore: number,
    storeScore: number,
    logisticsScore: number,
    content: string,
    attachment: string[],
}
/** 提交售后评论 */
export const submitAfterSaleReviewApi = (params: SubmitAfterSaleReviewParams) =>
    $http.post({ url: `/aftersale/v1/aftersale-reviews/`, body: params }).then((r: any) => r.data)

/** 获取售后评论详情 */
export const getAfterSaleReviewDetailApi = (reviewId: number | string) =>
    $http.get({ url: `/aftersale/v1/aftersale-reviews/${reviewId}` }).then((r: any) => r.data)

export interface GetAfterSaleOperationLogsParams {
    aftersaleId: number
    subOrderType?: string
}

/** 售后操作日志列表 */
export const getAfterSaleOperationLogsApi = (params: GetAfterSaleOperationLogsParams) =>
    $http
        .get({
            url: `/aftersale/v1/operation-logs/list`,
            params: { subOrderType: 'aftersale', ...params },
            loading: true
        })
        .then((r: any) => {
            if (Array.isArray(r)) return r
            if (Array.isArray(r?.data)) return r.data
            return []
        })
